import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="dialog-opener"
export default class extends Controller {
  static outlets = ['dialog']

  openDialog() {
    this.dialogOutlet.show()
  }
}
